import React, { useEffect, useState } from "react";
import axios from "axios";
import { useLocation, useNavigate } from "react-router-dom";
import PageLoader from "../components/PageLoader";

const RejectOffer = () => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [message, setMessage] = useState(""); // State to store API message
  const location = useLocation();
  const navigate = useNavigate();

  const getDataFromlocalStorage = (key) => {
    try {
      const serializedData = localStorage.getItem(key);
      return serializedData ? JSON.parse(serializedData) : null;
    } catch (error) {
      console.error("Error getting data from localStorage:", error);
      return null;
    }
  };

  useEffect(() => {
    const storedUserPreferences = getDataFromlocalStorage("userData");
    if (!storedUserPreferences) {
      navigate("/login", { state: { from: location.pathname + location.search } });
      return;
    }

    if (storedUserPreferences.role === "dealer") {
      setError("This offer link is for private buyers. Redirecting to your dealer dashboard...");
      setLoading(false);
      setTimeout(() => {
        navigate("/dealer/dashboard");
      }, 3000);
      return;
    }

    const searchParams = new URLSearchParams(location.search);
    const slug = searchParams.get("car");

    if (!slug) {
      setError("Request id is missing in the URL.");
      setLoading(false);
      return;
    }

    // API call to update car status
    axios
      .post(`${window.CARLOCA_API}/status/bidding-buyer`, {
        status: "reject-by-buyer",
        unid: slug,
      })
      .then((response) => {
        if (response?.data?.status) {
          setMessage(response?.data?.message || "Your rejection has been recorded successfully.");
          setLoading(false);
        } else {
          setError(response?.data?.message || "Failed to process your rejection.");
          setLoading(false);
        }
      })
      .catch((err) => {
        setError(err.response?.data?.message || "Failed to update car status.");
        setLoading(false);
      });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  if (loading) {
    return <PageLoader text="Processing your response..." />;
  }

  if (error) {
    return (
      <div className="cl-auth-page">
        <div className="cl-auth-card" style={{ maxWidth: 480 }}>
          <div className="text-center">
            <div className="cl-empty-icon" style={{ background: "#fde8e8" }}><i className="fa-solid fa-circle-exclamation" style={{ color: "#ef4444" }}></i></div>
            <h5 className="cl-empty-title mt-3">Something Went Wrong</h5>
            <p className="cl-empty-text">{error}</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="cl-auth-page">
      <div className="cl-auth-card" style={{ maxWidth: 480, textAlign: "center" }}>
        <div className="cl-empty-icon" style={{ background: "#fde8e8" }}><i className="fa-solid fa-ban" style={{ color: "#ef4444" }}></i></div>
        <h5 className="cl-page-title mt-3">Offer Rejected</h5>
        <p className="cl-page-subtitle">We have noted your decision. If you change your mind, feel free to explore other options.</p>
        <p style={{ color: "#374151", fontSize: "1rem" }}>{message}</p>
        <p className="cl-page-subtitle" style={{ fontSize: 14, marginTop: 16 }}>Your perfect car is still waiting for you!</p>
        <button className="cl-btn cl-btn-primary cl-btn-lg w-100 mt-3" onClick={() => window.open(window.CARLOCA_WEB + "/#/declined-request", "_blank")}>
          View Declined Offers
        </button>
      </div>
    </div>
  );
};

export default RejectOffer;
